import { AppstoreOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { useContext, useMemo } from 'react';
import { AppContext } from 'src/contexts/app.context';
import { getPathsFromRoles } from 'src/utils/utils';
import ModulesMenu from './ModulesMenu';

const ModulesMenuButton = () => {
  const { userInfo, isUserAdmin, roles } = useContext(AppContext);

  const paths = useMemo(() => {
    return getPathsFromRoles(roles);
  }, [roles]);

  return (
    <Dropdown
      dropdownRender={() => <ModulesMenu userInfo={userInfo} isUserAdmin={isUserAdmin} paths={paths} />}
      trigger={['click']}
      placement='bottomRight'
      mouseEnterDelay={0.1}
      mouseLeaveDelay={0.1}
    >
      <Button
        type='text'
        shape='round'
        size='large'
        icon={<AppstoreOutlined />}
        className='notification-btn'
        title='All Modules'
      />
    </Dropdown>
  );
};

export default ModulesMenuButton;
